export const PreQualifierAssetTypeListStyles = {
  container: 'my-4 flex flex-col flex-wrap',
  listContainer: 'flex flex-row justify-center flex-wrap mb-6',
  description:
    'text-center text-16px text-blue700 font-bold mt-4 sm:text-20px sm:font-semibold'
}
